<div class="pt-4 container">
  <div class="row flex-column flex-lg-nowrap flex-lg-row">
    <div class="mr-lg-5 mb-4 col-12 col-lg-6" *ngIf="imagePosition=='left'">
      <div #template></div>
    </div>

    <div [class]="imagePosition=='full-width' ? 'col-12' : 'col-lg-6 col-12' ">
         <div class="contnet">
          <kla-title [lineConfig]="lineConfig" [config]="titleConfigurations">
            <ng-content></ng-content>
          </kla-title>
        </div>
    </div>

    <div class="col-12 col-lg-6 mb-lg-4" *ngIf="imagePosition=='right'">
      <div #template></div>
    </div>
  </div>

  <div class="row mt-4 mb-4" *ngIf="imagePosition=='full-width'">
    <div class="col-12 text-center d-flex justify-content-center">
      <div class="w-100" #template></div>
    </div>
  </div>
</div>





